import { render, staticRenderFns } from "./DefaultHeaderDropdownMssgs.vue?vue&type=template&id=46fe575c&scoped=true"
import script from "./DefaultHeaderDropdownMssgs.vue?vue&type=script&lang=js"
export * from "./DefaultHeaderDropdownMssgs.vue?vue&type=script&lang=js"
import style0 from "./DefaultHeaderDropdownMssgs.vue?vue&type=style&index=0&id=46fe575c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fe575c",
  null
  
)

export default component.exports